import React from 'react'

function Icici() {
  return (
    <div>
      ICICI
    </div>
  )
}

export default Icici
